import { render, staticRenderFns } from "./RankingRubros.vue?vue&type=template&id=ca04dbaa&"
import script from "./RankingRubros.vue?vue&type=script&lang=js&"
export * from "./RankingRubros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports